module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-tangshan.0b7505bd.png";